import apiClient from '../apiClient';
import { GET_PAYMENT_SCHEME_DETAIL_BY_ID_URL } from '../apiUrl';

const getPaymentSchemeDetailByIdApi = Id => {
  return apiClient.get(GET_PAYMENT_SCHEME_DETAIL_BY_ID_URL(Id));
};

export default getPaymentSchemeDetailByIdApi;
